import { populateMarketplaceLibrarySearchEvent } from '../libs/populateEventArgs.js';

function sendMarketplaceLibrarySearchEvent(autocompleteMetrics, data, url) {
    const eventParameters = populateMarketplaceLibrarySearchEvent(autocompleteMetrics, data, url);
    Roblox.EventStream.SendEventWithTarget("MarketplaceLibrarySearch", "Library", eventParameters, Roblox.EventStream.TargetTypes.WWW);
}

export { sendMarketplaceLibrarySearchEvent };